import { useCallback } from "react"

import { useField, useFormikContext } from "formik"

import { L2RDatePicker } from "../../components/L2RDatePicker"

export const FormikDatePicker = (props) => {

    const {
        onChange,
        ...datePickerProps
    } = props

    const [fieldProps, metaProps] = useField(props)
    const { setStatus, setFieldValue } = useFormikContext()

    const handleChange = useCallback((value) => {
        setFieldValue(props.name, value)
        setStatus()
        onChange?.(value)
    }, [props, onChange, setFieldValue, setStatus])

    return <L2RDatePicker
        {...datePickerProps}
        {...fieldProps}
        {...((metaProps.error) ? {
            slotProps: {
                textField: {
                    error: true,
                    helperText: metaProps.error,
                },
            },
        } : {})}
        onChange={handleChange}
    />
}